export default __webpack_public_path__ + "static/media/login.220227c3.png";